import { jsx as _jsx } from "react/jsx-runtime";
import ScrollableTabs from "segments/desktop/core-components/scrollable-tabs/scrollable-tabs.js";
import classnames from "classnames";
import { StyledUsecasesGallery } from "./usecases-gallery-tabs-component.scss";
const UsecasesGalleryTabsComponent = (props)=>{
    const { usecases, defaultSelectedTabLabel, alignToLogo, withDividerLine, selectedIconBackground, maxWidth, tabWidth, contentMarginTop, tabContentMaxWidth, iconSize, segmentType } = props;
    const defaultSelectedTabIndex = usecases === null || usecases === void 0 ? void 0 : usecases.findIndex((tab)=>{
        var _tab_label;
        return ((_tab_label = tab.label) === null || _tab_label === void 0 ? void 0 : _tab_label.toLocaleLowerCase()) === (defaultSelectedTabLabel === null || defaultSelectedTabLabel === void 0 ? void 0 : defaultSelectedTabLabel.toLocaleLowerCase());
    });
    return /*#__PURE__*/ _jsx(StyledUsecasesGallery, {
        maxWidth: maxWidth,
        children: /*#__PURE__*/ _jsx("div", {
            className: classnames("usecases-gallery-tabs-component", {
                "align-to-logo": !!alignToLogo
            }),
            children: /*#__PURE__*/ _jsx(ScrollableTabs, {
                tabs: usecases,
                defaultSelectedTabIndex: defaultSelectedTabIndex,
                withDividerLine: withDividerLine,
                selectedIconBackground: selectedIconBackground,
                tabWidth: tabWidth,
                contentMarginTop: contentMarginTop,
                tabContentMaxWidth: tabContentMaxWidth,
                iconSize: iconSize,
                segmentType: segmentType
            })
        })
    });
};
export default UsecasesGalleryTabsComponent;
